import { Modal } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const ModalForm = ({ visible, form, title, children, callRequest, handleClose, okButtonProps, cancelButtonProps, confirmOnly, ...rest }) => {
  const { t } = useTranslation()
  const [isSubmitting, setSubmitting] = useState(false)
  const handleSubmitForm = async (values) => {
    setSubmitting(true)
    await callRequest(values)
    setSubmitting(false)
  }
  const onOk = async () => {
    form
      .validateFields()
      .then(confirmOnly ? callRequest : handleSubmitForm)
      .catch((info) => {
        console.log('Validate Failed:', info)
      })
  }
  return (
    <Modal
      visible={visible}
      title={title}
      okText={t('common.label.save')}
      cancelText={t('common.label.cancel')}
      okButtonProps={{ loading: isSubmitting, ...okButtonProps }}
      cancelButtonProps={{ disabled: isSubmitting, ...cancelButtonProps }}
      onCancel={handleClose}
      destroyOnClose={!isSubmitting}
      {...rest}
      onOk={onOk}
    >
      {children}
    </Modal>
  )
}
